import React, { useEffect, useRef, useState } from "react";
import { Grid, Divider, Box } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
} from "App/Component/ui";
import { useSelectOption } from "App/hooks";
import { EXCEL_DEFAULT_SEPARATOR, TYPE_INSTANCE1 } from "App/constants";
import { CSVLink } from "react-csv";
import { FilterColumns, PrepareDataExport } from "../../MasterData/helpers";
import { defaultToastError, isNull } from "App/utils/helpers";
import { exportAllDokter, FORM_FILTER_DOKTER, TIPE_TENAGA_MDIS } from "./utils";
import { DrawerMaster } from "components/molecules";
import ToggleMonitoringSyncIHS from "./ToggleMonitoringSyncIHS";

export default function FormFilterDokter({
  formFilter,
  setFormFilter,
  setNewData,
  onlyName = false,
}) {
  const csvLink = useRef(null);
  const [rowsExport, setRowsExport] = useState([]);
  const [readyExport, setReadyExport] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openMonitoring, setOpenMonitoring] = useState(false);
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const handleExport = async (e) => {
    e.preventDefault();
    setReadyExport(false);
    setIsLoading(true);

    const res = await exportAllDokter(formFilter);
    if (res.state) {
      setRowsExport(res.data);
      setReadyExport(true);
      setIsLoading(false);
    } else {
      setRowsExport([]);
      setReadyExport(false);
      setIsLoading(false);
      defaultToastError(res.message);
    }
    setRowsExport([]);
  };

  const prepareHeaders = {
    id: "id_dokter",
    id_user: "id_user",
    username: "username",
    id_ihs: "id_ihs",
    fullname: "nama",
    gender_name: "jenis_kelamin",
    dp_place: "tempat_lahir",
    dp_date: "tanggal_lahir:date",
    dp_region: "alamat",
    agama_name: "agama",
    dp_mobilephone: "no_hp",
    dp_phone: "no_telepon",
    dp_email: "email",
    dp_nik: "nik",
    dp_npwp: "npwp",
    status: "status",
    nik: "nip",
    tipe_tenaga_medis: "tipe_tenaga_medis",
    spec_name: "spesialis",
    spec_code: "code_spesialis",
    poli_name: "poli",
    hospital_code: "kode_RS",
    no_sep: "no_sip",
    tgl_sip: "tgl_sip:date",
    inisial: "inisial_dokter",
    qualification_name: "qualifikasi",
    dp_keahlian_khusus: "keahlian_khusus",
    dp_firstdoctordate: "tanggal_awal_menjadi_dokter:date",
    edu_bachelor: "instutitusi_S1",
    edu_diploma: "instutitusi_S2",
    edu_doctor: "instutitusi_S3",
    kj_establish_date: "tanggal_mulai_kerja:date",
    kj_str_number: "no_STR",
    kj_expired_date: "tanggal_STR_habis:date",
    kj_bpjsbridge: "kode_bridge",
    bank_name: "nama_bank",
    bk_norek: "no_rek",
    createdBy: "createdBy",
    createdAt: "inserted_time:date",
    createdName: "inserted_by",
    updatedAt: "updated_time:date",
    updatedName: "updated_by",
  };

  const dataExport = PrepareDataExport(rowsExport, prepareHeaders);
  const headerExport = FilterColumns(dataExport);

  useEffect(() => {
    if (csvLink && csvLink.current && readyExport) {
      csvLink.current.link.click();
    }
  }, [readyExport]);

  const toggleDrawer = (openMonitoring) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpenMonitoring(openMonitoring);
  };

  return (
    <>
      <DrawerMaster
        open={openMonitoring}
        toggleDrawer={toggleDrawer}
        widthList={900}
      >
        <ToggleMonitoringSyncIHS />
      </DrawerMaster>
      <form onSubmit={(e) => handleSubmit(e)}>
        {onlyName ? (
          <Grid container spacing={1}>
            <FilterFormOnlyName
              formFilter={formFilter}
              handleChange={handleChange}
            />
          </Grid>
        ) : (
          <>
            <Grid container spacing={1}>
              <FilterFormAll
                formFilter={formFilter}
                setFormFilter={setFormFilter}
                handleChange={handleChange}
              />
            </Grid>

            <br />
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <MasterButton
                name={"RESET"}
                type="button"
                outline={true}
                color={"danger"}
                size={"md"}
                onClick={(e) => setFormFilter(FORM_FILTER_DOKTER)}
              />
              <Box sx={{ display: "flex", gap: "16px" }}>
                <MasterButton
                  type={"button"}
                  color="warning"
                  name={isLoading ? "Loading..." : "EXPORT"}
                  disabled={isLoading}
                  size="md"
                  onClick={handleExport}
                />
                <CSVLink
                  filename={`Daftar Dokter.csv`}
                  data={dataExport ?? []}
                  headers={headerExport ?? []}
                  separator={EXCEL_DEFAULT_SEPARATOR}
                  target="_blank"
                  ref={csvLink}
                  style={{ display: "none" }}
                ></CSVLink>
                {/* <MasterButton
                  name={"MONITORING SINGKRONISASI BERJALAN"}
                  outline={true}
                  color={"green"}
                  onClick={() => setOpenMonitoring(!openMonitoring)}
                  type="button"
                  size={"md"}
                /> */}
                <MasterButton
                  name={"CARI"}
                  type="submit"
                  outline={true}
                  color={"green"}
                  size={"md"}
                />
              </Box>
            </Grid>

            <br />
            <Divider />
          </>
        )}
      </form>
    </>
  );
}

const FilterFormAll = ({ formFilter, handleChange, setFormFilter }) => {
  const poliklinik = useSelectOption(
    false,
    "/policlinic/listpoliclinic",
    TYPE_INSTANCE1
  );

  const spesialis = useSelectOption(
    false,
    "/spesialist/listspesialist_doctor",
    TYPE_INSTANCE1,
    "code",
    "name"
  );

  const hospital = useSelectOption(
    false,
    "/hospital/listhospital",
    TYPE_INSTANCE1,
    "code",
    "name"
  );
  return (
    <>
      {" "}
      <Grid item sm={3}>
        <InputTextMaster
          name="name"
          label="NAMA"
          id="name"
          autoFocus={true}
          value={formFilter.name}
          onChange={handleChange("name")}
          placeholder="Nama"
        />
      </Grid>
      <Grid item sm={3}>
        <InputTextMaster
          name="id_satu_sehat"
          label="ID SATU SEHAT"
          id="id_satu_sehat"
          autoFocus={true}
          value={formFilter.id_satu_sehat}
          onChange={handleChange("id_satu_sehat")}
          placeholder="ID Satu Sehat"
        />
      </Grid>
      <Grid item sm={3}>
        <InputOptionMaster
          name="tipe_tenaga_medis"
          label="Tipe Tenaga Medis"
          id="tipe_tenaga_medis"
          withSearch={true}
          value={formFilter.tipe_tenaga_medis}
          labelValue={formFilter.tipe_tenaga_medis_nama}
          onChange={(e) => {
            if (isNull(e)) {
              setFormFilter({
                ...formFilter,
                tipe_tenaga_medis: null,
                tipe_tenaga_medis_nama: "Pilih Tipe Tenaga Medis",
              });
            } else {
              setFormFilter({
                ...formFilter,
                tipe_tenaga_medis: e.value,
                tipe_tenaga_medis_nama: e.label,
              });
            }
          }}
          data={TIPE_TENAGA_MDIS}
        />
      </Grid>
      <Grid item sm={3}>
        <InputOptionMaster
          name="hospital_code"
          label="RUMAH SAKIT"
          id="hospital_code"
          needParse={false}
          withSearch={false}
          value={formFilter.hospital_code}
          onChange={handleChange("hospital_code")}
          data={hospital}
        />
      </Grid>
      <Grid item sm={4}>
        <InputOptionMaster
          name="poliklinik_id"
          label="POLIKLINIK"
          id="poliklinik_id"
          withSearch={false}
          value={formFilter.poliklinik_id}
          onChange={handleChange("poliklinik_id")}
          data={poliklinik}
        />
      </Grid>
      <Grid item sm={4}>
        <InputOptionMaster
          name="spec_code"
          label="SPESIALIS"
          id="spec_code"
          needParse={false}
          withSearch={false}
          value={formFilter.spec_code}
          onChange={handleChange("spec_code")}
          data={spesialis}
        />
      </Grid>
      <Grid item sm={4}>
        <InputOptionMaster
          name="status_dokter"
          label="STATUS"
          id="status_dokter"
          needParse={false}
          withSearch={false}
          value={formFilter.status}
          onChange={handleChange("status")}
          data={[
            {
              label: "SEMUA",
              value: "",
            },
            {
              label: "AKTIF",
              value: true,
            },
            {
              label: "TIDAK AKTIF",
              value: false,
            },
          ]}
        />
      </Grid>
    </>
  );
};
const FilterFormOnlyName = ({ formFilter, handleChange }) => {
  return (
    <>
      <Grid item sm={10}>
        <InputTextMaster
          name="name"
          label="Nama"
          autoFocus={true}
          id="name"
          value={formFilter.name}
          onChange={handleChange("name")}
          placeholder="Nama Dokter"
        />
      </Grid>
      <Grid item sm={2}>
        <div
          style={{
            marginTop: "1.5rem",
          }}
        >
          <MasterButton
            name={"CARI"}
            type="submit"
            outline={true}
            color={"green"}
            size={"md"}
          />
        </div>
      </Grid>
    </>
  );
};
